import { CommonModule, NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Roles } from '@edtech-ui/constants/roles.enum';
import { ClassroomManagementService } from '@edtech-ui/core/services/classroom-management-service/classroom-management.service';
import { ToastrService } from 'ngx-toastr';
import { map, Observable, Subscription, tap } from 'rxjs';

interface AcceptClassCodeParams {
	class_id?: number;
	class_code?: string;
	user_name?: string;
	email?: string;
	user_id?: string;
	role?: Roles;
}

@Component({
	selector: 'app-accept-class-code',
	standalone: true,
	imports: [NgIf, CommonModule],
	templateUrl: './accept-class-code.component.html',
	styleUrl: './accept-class-code.component.scss'
})
export class AcceptClassCodeComponent implements OnInit, OnDestroy {

	subscription = new Subscription();
	acceptClassCodeParams$: Observable<AcceptClassCodeParams>;
	acceptClassCodeParams: AcceptClassCodeParams = {};
	_Roles = Roles;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private _classroomService: ClassroomManagementService,
		private _toastr: ToastrService
	) {
		this.acceptClassCodeParams$ = new Observable<AcceptClassCodeParams>;
	}


	ngOnInit(): void {
		this.acceptClassCodeParams$ = this.route.queryParams.pipe(
			map((values) => ({
				...values,
				role: values['role'] ? Number(values['role']) as Roles : undefined
			})),
			tap((values) => this.acceptClassCodeParams = values)
		);
	}

	acceptInvite() {
		this.subscription.add(
			this._classroomService.postJoinClass({
				user_id: this.acceptClassCodeParams.user_id,
				class_code: this.acceptClassCodeParams.class_code,
			}).pipe(
				tap(response => {
					if (response.Success) {
						this._toastr.success('You have joined the Class Successfully');
						switch (this.acceptClassCodeParams.role) {
							case Roles.TEACHER:
								this.router.navigate([`/teacher-dashboard/classroom-detail-page/${this.acceptClassCodeParams.class_id}/member`]);
								break;
							case Roles.STUDENT:
								this.router.navigate([`/student-dashboard/classroom-detail-page/${this.acceptClassCodeParams.class_id}/members`]);
								break;
							default:
								this._toastr.warning('Unknown role, unable to redirect');
						}
					} else{
						this._toastr.error(response.Message);
					}
				})
			).subscribe()
		);
	}


	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

}	